import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang, t } from "@/context/LangContext";
import { Link } from "react-router-dom";
import { TrendingUp, AlertTriangle } from "lucide-react";

const Recommendations = () => {
  const { lang } = useLang();
  const [recs, setRecs] = useState([]);
  const [market, setMarket] = useState("all");

  useEffect(() => {
    const q = { params: {} };
    if (market !== "all") q.params.market = market === "id" ? "Indonesia" : "US";
    api.get("/recommendations", q).then((r) => setRecs(r.data.recommendations || []));
  }, [market]);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12" data-testid="recs-page">
      <div className="overline text-white/40 mb-3">{t(lang, "Pilihan Kurator", "Curator's Picks")}</div>
      <h1 className="font-display font-black text-5xl md:text-6xl tracking-tighter mb-8">
        {t(lang, "Rekomendasi Saham", "Stock Recommendations")}
      </h1>

      <div className="inline-flex border border-white/10 rounded-md overflow-hidden mb-8" data-testid="rec-market-filter">
        {[
          { id: "all", label: "All" },
          { id: "id", label: "Indonesia" },
          { id: "us", label: "USA" },
        ].map((f) => (
          <button
            key={f.id}
            onClick={() => setMarket(f.id)}
            data-testid={`rec-filter-${f.id}`}
            className={`px-5 py-2 text-sm font-medium transition-colors ${market === f.id ? "bg-white text-black" : "text-white/60 hover:text-white hover:bg-white/5"}`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        {recs.map((r) => (
          <div key={r.symbol} data-testid={`rec-${r.symbol}`} className="border border-white/10 rounded-2xl p-6 lg:p-8 trace-card bg-[#0d0d0d] flex flex-col">
            <div className="flex items-start justify-between mb-4">
              <div>
                <div className="overline text-white/40 mb-1">{r.market} · {r.conviction} Conviction</div>
                <Link to={`/analysis/${encodeURIComponent(r.symbol)}`} className="font-display font-black text-2xl tracking-tight hover:underline">
                  {r.symbol}
                </Link>
                <div className="text-white/60 text-sm">{r.stock_name}</div>
              </div>
              <span className={`overline px-3 py-1 rounded-full ${r.action === "BUY" ? "bg-emerald-500/20 text-emerald-400" : r.action === "HOLD" ? "bg-yellow-500/20 text-yellow-400" : "bg-rose-500/20 text-rose-400"}`}>
                {r.action}
              </span>
            </div>

            <div className="grid grid-cols-3 gap-3 my-4">
              <div>
                <div className="overline text-white/40 mb-1">{t(lang, "Harga", "Price")}</div>
                <div className="font-mono font-bold">{r.market === "Indonesia" ? "Rp " + r.current_price.toLocaleString("id-ID") : "$" + r.current_price.toFixed(2)}</div>
              </div>
              <div>
                <div className="overline text-white/40 mb-1">Target</div>
                <div className="font-mono font-bold">{r.market === "Indonesia" ? "Rp " + r.target_price.toLocaleString("id-ID") : "$" + r.target_price.toFixed(2)}</div>
              </div>
              <div>
                <div className="overline text-white/40 mb-1">Upside</div>
                <div className="font-mono font-bold text-emerald-400 flex items-center gap-1"><TrendingUp size={14} />{r.upside}%</div>
              </div>
            </div>

            <div className="mb-3">
              <div className="overline text-white/40 mb-2">Thesis</div>
              <p className="text-sm text-white/70 leading-relaxed">{r.thesis}</p>
            </div>
            <div>
              <div className="overline text-white/40 mb-2 flex items-center gap-1.5"><AlertTriangle size={11} /> {t(lang, "Risiko", "Risk")}</div>
              <p className="text-sm text-white/60 leading-relaxed">{r.risk}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Recommendations;
